<template>
  <div>
    <div
      id="modal-title"
      class="modal-header"
    >
      <h3>{{ $t('notifier.delete') }}</h3>
    </div>
    <div class="modal-content">
      <div class="edit-queue">
        <form
          id="form-delete-notifier"
        >
          <p>{{ $t('notifier.delete.description') }}  <strong>"{{ notifier.serviceID }}"</strong>.</p>

          <div class="form-actions">
            <button
              type="button"
              class="btn-secondary"
              @click="close"
            >
              {{ $t('cancel') }}
            </button>
            <button
              type="button"
              class="btn-warning btn-active main-action"
              @click="deleteNotifier()"
            >
              {{ $t('delete') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import notifiers from '@/api/notifiers'

export default {
  name: 'RemoveNotifier',
  props: {
    notifier: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapActions(['fetchNotifiers']),
    async close () {
      this.$emit('input', false)
    },
    deleteNotifier () {
      notifiers.deleteNotifier({ id: this.notifier.id })
      this.fetchNotifiers()
      this.close()
    }
  }
}
</script>
